import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import { colorBorderGrey, colorVeryLightGrey } from 'styles/base';

const baseUrl = process.env.REACT_APP_WINDOW_URL;


const title = css`
    padding: 10px 20px;
    font-size: 20px;
    border-bottom: 1px solid ${colorBorderGrey};
`;

const body = css`
    padding: 20px;
    background-color: ${colorVeryLightGrey};
    border-bottom: 1px solid ${colorBorderGrey};
`

const list = css`
    
    li {
        padding: 2px;
    }
`;


/**
 * This form lets you run a vap (or ingest with variable retrieval) via the data consolidator and
 * interact with past runs.
 */
export default class ProcessTutorials extends React.Component {
    render() {
        return (
            <Flexbox flexDirection='column' flexGrow={1}>
                <Flexbox className={title}>
                    <strong>PCM Tutorial Series</strong>
                </Flexbox>
                <Flexbox className={body}>
                    <ol className={list}>
                        <li><a href={`${baseUrl}/documents/adi_demo1.pdf`} target="_blank">Use PCM Wizard to Transform Data</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo2.pdf`} target="_blank">Transform onto 30-minute Grid Using Nearest Neighbor</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo3.pdf`} target="_blank">Demonstrate Range Transformation Parameter</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo4.pdf`} target="_blank">Retrieve Data from a Second Input Datastream and Map It to an Existing Coordinate System and Output Datastream</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo5.pdf`} target="_blank">reate a Second Output Datastream with a Different Coordinate Grid</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo6.pdf`} target="_blank">Transform a Variable’s Second Dimension</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo7.pdf`} target="_blank">Setting Alignment Transform Parameter</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo8.pdf`} target="_blank">Setting Standard Deviation QC Assessments on Bin Averaged Data</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo9.pdf`} target="_blank">Setting Fraction of ‘Good’ QC Input Data Parameter</a></li>
                        <li><a href={`${baseUrl}/documents/adi_demo10.pdf`} target="_blank">Setting qc_mask Transform Parameter</a></li>
                    </ol>
                </Flexbox>
            </Flexbox>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/page/process/ProcessTutorials.js